<template>
  <BaseModalWindow :header="false">
    <div class="delete">
      <div class="delete__header">
        <h2 class="delete__title">
          Вы уверены?
        </h2>
        <div class="delete__line"></div>
      </div>
      <p class="delete__text">
        Вы собираетесь удалить элемент, после удаления его нельзя будет восстановить
      </p>
      <div class="delete__buttons buttons">
        <button class="buttons__remove" @click="$emit('cancel')"><CancelIcon/> Отмена</button>
        <button class="buttons__cancel" @click="$emit('remove')"><approweIcon/>Подтвердить</button>
      </div>
    </div>
  </BaseModalWindow>
</template>

<script>
import BaseModalWindow from '@/components/modals/BaseModalWindow'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import approweIcon from '@/components/icons/approweIcon.vue'
export default {
  name: 'ConfirmDelete',
  components: {
    BaseModalWindow,
    CancelIcon,
    approweIcon
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.delete {
  display: flex;
  flex-direction: column;
  text-align: left;

  &__header {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 16px;
    width: 100%;
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
  }

  &__line {
    display: block;
    flex: 1;
    height: 2px;
    background-color: #C8C8C8;
  }

  &__text {
    margin-bottom: 32px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
}

.buttons {
  position: absolute;
    right: 0px;
    left: 0px;
    bottom: 0px;
    padding: 24px;
    border-top: 2px solid #D6D6D6;
    background-color: #F5F5F5;
    display: flex;
    justify-content: flex-end;
    gap: 30px;
    width: 100%;

  &__remove, &__cancel {
    display: flex;
    align-items: center;
    gap: 16px;
    border-radius: 6px;
    width: 200px;
    color: #FFFFFF;
    transition: 0.8s;
    cursor: pointer;
  }

  &__remove {
    padding: 10px 12px;
    background-color: #C51B0E;
    &:hover {
      background-color: #A11208;
      color: #FFFFFF;
    }
  }

  &__cancel {
    padding: 12px 10px;
    background-color: #00ABEC;

    :deep(svg) {
      path {
        stroke: white;
      }
    }
    &:hover {
      background-color: #0080B0;
      color: #FFFFFF;
    }
  }
}
:deep(.modal) {
  padding: 24px;
  width: 500px;
  height: 220px
}
</style>
